import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputCheckboxMaster,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_KUNJUNGAN_TEXT_DISPLAY = {
  id: "",
  judul: "",
  text: "",
  remark: "",
  durasi: "",
  isactive: 1,
};

export const urlGet = LIST_URL_MASTER.text_display_kunjungan.list;
export const urlAdd = LIST_URL_MASTER.text_display_kunjungan.add;
export const urlUpdate = LIST_URL_MASTER.text_display_kunjungan.update;
export const urlDelete = LIST_URL_MASTER.text_display_kunjungan.delete;

export const deleteKunjunganTextDisplayById = async (id) => {
  try {
    await instance2.post(
      urlDelete,
      {},
      {
        headers: {
          iddisplaytext_kunjungan: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "judul",
    disablePadding: false,
    label: "JUDUL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "text",
    disablePadding: false,
    label: "TEXT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "durasi",
    disablePadding: false,
    label: "DURASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance2.post(urlAdd, {
      ...formData,
    });
  };

  const update = () => {
    return instance2.post(
      urlUpdate,
      {
        ...formData,
      },
      {
        headers: {
          iddisplaytext_kunjungan: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.judul === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah data");
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah data");
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_KUNJUNGAN_TEXT_DISPLAY);
        setShowModal(false);
        setNewData();
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Kunjungan Text Display`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='judul'
              label='Judul'
              id='judul'
              value={formData.judul}
              onChange={handleChange("judul")}
              placeholder='Judul'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='text'
              label='Text'
              id='text'
              value={formData.text}
              onChange={handleChange("text")}
              placeholder='Text'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='durasi'
              label='Durasi'
              id='durasi'
              value={formData.durasi}
              onChange={handleChange("durasi")}
              placeholder='Durasi'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Keterangan'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Keterangan'
            />
          </Grid>
          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.isactive}
              name='isactive'
              id='isactive'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, isactive: !formData.isactive })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
